import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';

import TableRow from '@material-ui/core/TableRow';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from '@material-ui/core/Paper';

import Pagination from '@material-ui/lab/Pagination';

import {
    Collapse,
    Grid,
    Typography,
    withStyles
} from "@material-ui/core";


import Filters from "./Filters";

import {MuiThemeProvider} from "material-ui";

import Button from "@material-ui/core/Button";
import Select from "../../components/Select";

import Http from "../../Http";
import {STAT_ROUTES} from "../../config/routes";
import TableHead from "@material-ui/core/TableHead";
import {decodeEntities, formattedDateTime} from "../../utils/functions";
import AlertMessage from "../../components/AlertMessage";
import StatByDay from "./StatByDay";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import {withRouter} from "react-router-dom";
import {parseFiltersFromSearch, syncFiltersToUrl} from "../../utils/urlFilters";

const STAT_FILTERS_SCHEMA = {
    page: 'number',
    rowPerPage: 'pageSize',
    dateFrom: 'date',
    dateTo: 'date',
    login: 'string',
    site: 'string',
    type: 'string',
};


const StyledTableRow = withStyles((theme) => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.action.hover,
        // },
        '&:hover': {
            cursor: 'pointer'
        }
    },
}))(TableRow);

function EnhancedTableHead() {
    return (
        <TableHead>
            <StyledTableRow>
                <TableCell align={'center'}></TableCell>
                <TableCell align={'center'}>{'ID анкеты'}</TableCell>
                <TableCell align={'center'}>{'Сайт'}</TableCell>
                <TableCell align={'center'}>{'Общее время работы за период'}</TableCell>
                <TableCell align={'center'}>{'Количество отправленных за период'}</TableCell>
            </StyledTableRow>
        </TableHead>
    );
}

const styles = theme => ({
    root: {
        width: '100%',

    },
    sec: {
        color: theme.palette.secondary.main
    },
    prim: {
        color: theme.palette.primary.main
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {},
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    selectedRow: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    button: {
        color: '#fff',
        marginLeft: '10px',
        marginBottom: '10px',
        width: '200px'
    },
    selectedPagin: {
        color: '#ffffff'
    },
    '@global': {
        '.MuiPaginationItem-textPrimary.Mui-selected': {
            color: '#ffffff'
        }
    },
    disabledSwitch: {}
});

class Stat extends React.Component {

    constructor(props) {
        super(props);
        let date = new Date();
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate() - 1)
        let date2 = new Date();
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);

        const urlFilters = parseFiltersFromSearch(props.location.search, STAT_FILTERS_SCHEMA);

        this.state = {

            rowPerPage: urlFilters.rowPerPage || 10,
            filters: {
                login: urlFilters.login || '',
                site: urlFilters.site || '',
                dateFrom: urlFilters.dateFrom || date,
                dateTo: urlFilters.dateTo || date2,
                type: urlFilters.type || ''
            },
            expandedData: [],
            expanded: false,
            displayType: 'common',
            page: urlFilters.page || 1,
            asyncStatus: 'failed',
            data: [],
            clientId: null,
        }

    }

    syncUrl = (overrides = {}) => {
        const {filters, page, rowPerPage} = this.state;
        syncFiltersToUrl(this.props.history, {...filters, page, rowPerPage, ...overrides});
    }

    filterBy = (value, type) => {
        const {filters} = this.state;
        this.setState({filters: {...filters, [type]: value}})
    }


    handleChangePage = (event, newPage) => {
        const {rowPerPage, page} = this.state;
        this.setState({page: newPage});
        this.syncUrl({page: newPage});
    };

    handleChangeRowsPerPage = (event) => {
        const {rowPerPage, page} = this.state;
        event = event === 'ВСЕ' ? event : parseInt(event, 10);
        this.setState({
            rowPerPage: event,
            page: 1
        })
        this.syncUrl({rowPerPage: event, page: 1});
    };

    getFormattedTime = (mins) => {
        let days = Math.floor(mins / (60 * 24))
        let hours = Math.floor((mins - days * 24 * 60) / 60)
        let minutes = mins - hours * 60 - days * 24 * 60
        return (

            <span><b style={{fontSize: '18px'}}>{days}</b> дней <b style={{fontSize: '18px'}}>{hours}</b> часов <b
                style={{fontSize: '18px'}}>{minutes}</b> минут</span>
        )
    }
    
    getFormattedTimeWrapped = (mins) => {

        return (
            <TableCell align="center">
                {this.getFormattedTime(mins)}
            </TableCell>
        )
    }

    getSliced = (clients) => {
        const {rowPerPage, page} = this.state;
        return rowPerPage !== 'ВСЕ' ? clients.slice((page - 1) * rowPerPage, (page - 1) * rowPerPage + rowPerPage) : clients
    }

    getStat(type = 'common', clientId = null) {
        if (type === 'direct' && clientId) {
            this.setState({displayType: type, clientId, data: [], page: 1, expandedData: [], expanded:false})
        } else {
            this.setState({displayType: 'common', clientId: null, data: [], page: 1, expandedData: [], expanded:false})
        }
        this.syncUrl({page: 1});
        let filters = this.state.filters;

        var dateTo = filters.dateTo
        var dateFrom = filters.dateFrom
        if (type === 'common' || clientId == null) {
            Http.post(STAT_ROUTES.getCommonUserStat, {filters: {...filters, dateFrom, dateTo}}).then(data => {
                this.setState({data: data.data})
            })
        } else {
            Http.post(STAT_ROUTES.getCommonUserStat, {filters, clientId}).then(data => {
                this.setState({data: data.data})
            })
        }
    }

    setType(type, clientId = null) {

        this.getStat(type, clientId);
    }

    handleExpand = (id) => {
        const {filters, expanded} = this.state;
        this.setState({expandedData: [], expanded: false})
        Http.post(STAT_ROUTES.getCommonUserStatGroupedByDay, {filters, clientId: id}).then(data => {
            this.setState({expandedData: data.data, expanded: expanded !== id ? id : false})
        })
    }

    componentDidMount() {
        this.getStat();
    }

    render() {
        const {rowPerPage, page, order, orderBy, data, displayType, clientId, expanded, expandedData} = this.state;
        const {classes} = this.props;

        let statData = this.getSliced(data);
        return (
            <div className={classes.root}>
                <Filters
                    onClickToAddNew={() => {
                        this.setState({addUsersDialogOpen: true})
                    }}
                    filterBy={this.filterBy}
                    filters={this.state.filters}
                    type={displayType}
                    setType={(type) => this.setType(type)}
                    applyFiltersCallback={() => this.getStat(displayType, clientId)}
                />

                <Paper component={'div'} className={classes.paper}>


                    {displayType === 'common' && <TableContainer>
                        <Table
                            stickyHeader
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'small'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                page={page}
                                rowCount={statData.length}
                            />

                            <TableBody>
                                {statData
                                    .map((row, index) => {
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        return (
                                            <>
                                                <StyledTableRow
                                                    tabIndex={-1}
                                                    key={row.login}
                                                >
                                                    <MuiThemeProvider>
                                                       
                                                        <TableCell component="th" id={labelId} scope="row"
                                                                   align="center">
                                                            <Button
                                                                size={'small'}
                                                                variant={'contained'}
                                                                color={'primary'}
                                                                onClick={() => this.setType('direct', row.client_id)}
                                                                style={{borderRadius: '50px', color: '#fff'}}
                                                            >
                                                                Подробнее
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell component="th" id={labelId} scope="row"
                                                                   align="center">
                                                            {row.login}
                                                        </TableCell>
                                                        <TableCell align="center" style={{
                                                            color: '#6495ed',
                                                            fontSize: '1rem'
                                                        }}>{row.siteName}</TableCell>

                                                        {this.getFormattedTimeWrapped(row.total_time)}

                                                        <TableCell align="center">{row.count}</TableCell>
                                                        <Button onClick={() => this.handleExpand(row.client_id)}>
                                                            {expanded === row.client_id ? <ExpandLess/> : <ExpandMore/>}
                                                        </Button>

                                                      
                                                    </MuiThemeProvider>

                                                </StyledTableRow>
                                                <TableRow style={{border: 0}}>
                                                    <TableCell colSpan={7} style={{border: 0, padding: 0}}>
                                                        <Collapse in={expanded === row.client_id} timeout={{
                                                            appear: 1000,
                                                            exit: 0,
                                                            enter: 1000
                                                        }}
                                                                  unmountOnExit>
                                                            <StatByDay data={expandedData}/>
                                                        </Collapse>
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        );
                                    })}

                            </TableBody>

                        </Table>
                    </TableContainer>}

                    {displayType === 'direct' && <TableContainer>
                        <Table
                            stickyHeader
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'small'}
                            aria-label="enhanced table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <TableCell align={'center'}>{'ID анкеты'}</TableCell>
                                    <TableCell align={'center'}>{'Тексты отправки'}</TableCell>
                                    <TableCell align={'center'}>{'Старт/стоп сессии'}</TableCell>
                                    <TableCell align={'center'}>{'Время сессии'}</TableCell>
                                    <TableCell align={'center'}>{'Кол-во отправок за сессию'}</TableCell>
                                    <TableCell align={'center'}>{'Ответов'}</TableCell>
                                </StyledTableRow>
                            </TableHead>

                            <TableBody>
                                {statData
                                    .map((row, index) => {
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        let preview = decodeEntities(row.text);
                                        preview = preview.replaceAll('{br}', '<br />')
                                        if (preview.length > 300) {
                                            preview = preview.slice(0, 300) + '.....<br />...................'
                                        }

                                        return (

                                            <StyledTableRow
                                                hover={true}
                                                tabIndex={-1}
                                                key={row.login}

                                            >
                                                <MuiThemeProvider>

                                                    <TableCell component="th" id={labelId} scope="row" align="center">
                                                        {row.login}
                                                    </TableCell>
                                                    <TableCell align="center" size={'medium'}>
                                                        <AlertMessage
                                                            title={''}
                                                            content={row.text.replaceAll('{br}', '<br />')}
                                                        >
                                                            <div dangerouslySetInnerHTML={{__html: preview}}/>
                                                        </AlertMessage>
                                                    </TableCell>
                                                    <TableCell>
                                                        {formattedDateTime(row.created_at)}<br/>
                                                        {formattedDateTime(row.updated_at)}
                                                    </TableCell>
                                                    {this.getFormattedTimeWrapped(row.total_time)}
                                                    <TableCell align="center">{row.count}</TableCell>

                                                </MuiThemeProvider>
                                            </StyledTableRow>

                                        );
                                    })}

                            </TableBody>

                        </Table>
                    </TableContainer>}

                </Paper>
                <Grid container>
                    <Grid item xs={7} sm={7} md={7} lg={7}></Grid>
                    <Grid item xs={5} sm={5} md={5} lg={5} style={{
                        display: 'flex',
                        aligItems: 'center',
                        fontSize: '11px',
                        alignItems: 'center',
                        color: 'gray'
                    }}>
                        <Typography variant={'span'} style={{'marginRight': '10px'}}>
                            Записей на странице
                        </Typography>
                        <Select
                            type={'select'}
                            rowsPerPageOptions={[10, 25, 50, 100, 'ВСЕ']}
                            borderRadius={'20px 20px'}
                            width={'76px'}
                            onChange={this.handleChangeRowsPerPage}
                        />

                        {rowPerPage !== 'ВСЕ' && <Pagination
                            classes={{selected: classes.selectedPagin}}
                            count={Math.ceil(data.length / rowPerPage)}
                            color="primary"
                            page={page}
                            onChange={this.handleChangePage}
                            size={'large'}/>}
                    </Grid>
                </Grid>

            </div>
        );
    }

}

export default withRouter(withStyles(styles)(Stat))